import { takeLatest, call, put } from "redux-saga/effects";
import {
  GET_GCP_SECRET_MANAGER,
  GET_GCP_SECRET_MANAGER_SUCCESS,
  GET_GCP_SECRET_MANAGER_ERROR,
} from "./constant";

import { getGCPSecretManagerApi } from "./api";

function* getGCPSecretManagerList(params) {
  try {
    const data = yield call(getGCPSecretManagerApi, params);
    yield put({ type: GET_GCP_SECRET_MANAGER_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_GCP_SECRET_MANAGER_ERROR, error });
  }
}

export function* manageGCPSecretManagerSaga() {
  yield takeLatest(GET_GCP_SECRET_MANAGER, getGCPSecretManagerList);
}
